/* OB Event Guide tweaks loader (Oct 22 2026).
   The original tweaks script now lives in ob-guide-tweaks-base.js (unchanged copy). This file loads it,
   then ob-guide-visual.js (event photo loading + OB Picks fallback tiles; styles are in ob-guide-tweaks.css).
   Oct 25 2026: also loads ob-guide-wingman-spots.js (venue strip shown when Wingman Mode is on).
   Undo the visual polish: delete the second entry below. Undo Wingman Spots: delete the third entry.
   Undo everything: copy ob-guide-tweaks-base.js back over this file. */
(function () {
  var me = document.currentScript || Array.prototype.filter.call(document.scripts, function (s) { return /ob-guide-tweaks\.js/.test(s.src); })[0];
  var dir = me && me.src ? me.src.replace(/ob-guide-tweaks\.js(\?.*)?$/, '') : '';
  if (!dir) return;
  ['ob-guide-tweaks-base.js', 'ob-guide-visual.js?v=20261022b', 'ob-guide-wingman-spots.js?v=20261025e'].forEach(function (f) {
    var s = document.createElement('script');
    s.src = dir + f;
    s.async = false;
    document.head.appendChild(s);
  });
})();
